module.exports = __webpack_public_path__ + "static/media/2.37efd45d.png";